module.exports = __webpack_public_path__ + "img/CMHKBEFORE_02_zhTc.aa32a77c.png";